import React from 'react';
import { Content, Row, Col, Title, Button } from 'components';
import Sub1 from 'assets/subscribe_image1.png';
import Sub2 from 'assets/subscribe_image2.png';
import { useUserStack } from 'store';
import './ProductSubscribe.style.css';

const ProductSubscribe = (props) => {
  /* ===== Props ===== */
  const { navigate, screenSize, products, onChange } = props;

  const userInfo = useUserStack();

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 72 : 40,
      fontFamily: `"Dela Gothic One", sans-serif`,
      fontWeight: 400,
      fontStyle: 'normal',
      textTransform: 'capitalize',
      marginBottom: screenSize >= 768 ? 100 : 60,
    },
    imageWrap: {
      padding: 0,
      width: '100%',
      height: screenSize >= 768 ? '41.66vw' : '102vw',
      backgroundColor: '#efefef',
      overflow: 'hidden',
    },
    subscribeImage: {
      borderRadius: 15,
      backgroundColor: '#fff',
      border: '1px solid #ddd',
      height: screenSize >= 768 ? '34.37vw' : '83vw',
    },
  };
  /* ===== State ===== */

  // active 상태를 관리할 state
  const [activeTags, setActiveTags] = React.useState([]);

  // 버튼 클릭 시 active 토글 함수
  const handleTagClick = (tag) => {
    const fid = activeTags?.findIndex((t) => t?.id === tag?.id);

    if (fid === -1) {
      setActiveTags((prev) => [...prev, tag]);
    } else {
      setActiveTags((prev) => [...prev.slice(0, fid), ...prev.slice(fid + 1)]);
    }
  };

  const handleNavigate = (path = '', auth = false) => {
    if (auth && !userInfo) {
      const confirm = '로그인 후 이용가능합니다.\n로그인하시겠습니까?';

      if (!confirm) return;

      navigate('signin', {
        state: {
          from: `${path}`,
        },
      });
    }

    navigate(path);
  };
  /* ===== Hooks ===== */
  /**
   * 정기배송 상품 태그 정재
   * --
   */
  const Tags = React.useMemo(() => {
    // 정기배송 상품 추출
    const subscription = products
      ?.filter((product) => product?.type === 'SUBSCRIPTION')
      ?.reduce((acc, cur) => {
        acc = acc.concat(cur?.tags);
        return acc;
      }, []);

    // 중복 제거
    const tagList = subscription?.reduce((acc, cur) => {
      const isExist = acc?.some((tag) => tag?.id === cur?.id);

      if (!isExist) {
        acc.push(cur);
      }

      return acc;
    }, []);

    return tagList;
  }, [products]);

  React.useEffect(() => {
    if (onChange) {
      onChange(activeTags);
    }
  }, [activeTags]);

  /* ===== Function ===== */

  /* ===== Render ===== */
  return (
    <React.Fragment>
      <div
        className="product_subscribe"
        style={{
          overflow: 'hidden',
        }}
      >
        <Row
          gutter={16}
          style={{
            width: '100%',
            overflow: 'hidden',
          }}
        >
          <Col
            x={24}
            style={{
              padding: 0,
            }}
          >
            <div
              style={{
                backgroundImage: `url("/jm-coffee-roasters-main-02_1920x675.jpg")`,
                //marginBottom: 200,
                position: 'relative',
              }}
              className="regulatdelivery"
            >
              <Content
                maxWidth={'100%'}
                backgroundColor="rgba(0,0,0,0.6)"
                padding={screenSize >= 500 ? '150px 15px' : '60px 0'}
                style={{
                  margin: '0 auto',
                  textAlign: 'center',
                }}
              >
                <Title
                  color="#fff"
                  align="center"
                  style={{ fontSize: screenSize >= 768 ? 30 : 18 }}
                >
                  결제 한 번으로 편하게
                </Title>
                <Title
                  align="center"
                  color="#fff"
                  style={{
                    fontSize:
                      screenSize >= 768 ? 64 : screenSize >= 500 ? 30 : 26,
                    lineHeight: '150%',
                  }}
                >
                  정기 구독 서비스
                </Title>
              </Content>
            </div>
          </Col>
          <Col
            x={24}
            style={{
              marginTop: screenSize >= 768 ? 100 : 60,
              padding: '60px 30px',
              width: '100%',
              backgroundColor: '#efefef',
              borderRadius: 25,
            }}
          >
            <Title
              align="center"
              style={{
                fontSize: screenSize >= 768 ? 50 : 26,
                lineHeight: '150%',
              }}
            >
              정기배송 신청방법
            </Title>
            <Row gutter={16} style={{ marginTop: screenSize >= 768 ? 60 : 30 }}>
              <Col
                x={24}
                md={12}
                padding={screenSize >= 768 ? '0 30px' : '0 15px'}
              >
                <div
                  style={{
                    ...styles.imageWrap,
                    ...styles.subscribeImage,
                  }}
                >
                  <img
                    src={Sub1}
                    alt="정기배송 안내1"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </div>
              </Col>
              <Col
                x={24}
                md={12}
                padding={screenSize >= 768 ? '0 30px' : '15px 15px 0'}
              >
                <div
                  style={{
                    ...styles.imageWrap,
                    ...styles.subscribeImage,
                  }}
                >
                  <img
                    src={Sub2}
                    alt="정기배송 안내2"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Col>

          <Button
            className={'sub_button'}
            onClick={() => handleNavigate(`/mypage/subscribe`, true)}
            style={{ fontSize: screenSize >= 768 ? 32 : 16 }}
          >
            정기배송 조회 & 결제카드 관리
          </Button>
        </Row>
        {/* 태그 버튼 */}
        <div className="tag_wrap">
          {Tags?.map((tag, index) => (
            <Button
              key={`${tag?.label}-${tag?.id}-${index}`}
              className={
                activeTags.some((t) => t?.id === tag?.id) ? 'active' : ''
              }
              onClick={() => handleTagClick(tag)}
            >
              {`# ${tag?.label}`}
            </Button>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProductSubscribe;
